import ChannelPopups from './src/main.vue';

ChannelPopups.install = function (Vue) {
 Vue.component(ChannelPopups.name, ChannelPopups);
}

export default ChannelPopups;
